import React, { useEffect, useRef } from "react";

// Code enseigne Mondial Relay (widget point relais) — public, exposé côté client.
const BRAND = "CC23JJ9G";

let loaderPromise = null;

const loadScript = (src) =>
  new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      if (existing.dataset.loaded) return resolve();
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", reject);
      return;
    }
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = () => { s.dataset.loaded = "1"; resolve(); };
    s.onerror = reject;
    document.body.appendChild(s);
  });

const ensureWidget = () => {
  if (loaderPromise) return loaderPromise;
  loaderPromise = (async () => {
    if (!window.jQuery) {
      await loadScript("https://ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js");
    }
    await loadScript(
      "https://widget.mondialrelay.com/parcelshop-picker/jquery.plugin.mondialrelay.parcelshoppicker.min.js"
    );
  })();
  return loaderPromise;
};

export const MondialRelayPicker = ({ onSelect }) => {
  const ref = useRef(null);
  const onSelectRef = useRef(onSelect);
  onSelectRef.current = onSelect;

  useEffect(() => {
    let cancelled = false;
    ensureWidget()
      .then(() => {
        if (cancelled || !ref.current || !window.jQuery) return;
        const $ = window.jQuery;
        $(ref.current).MR_ParcelShopPicker({
          Target: "#mr-selected-id",
          Brand: BRAND,
          Country: "FR",
          Responsive: true,
          ShowResultsOnMap: true,
          AutoSelect: "",
          OnParcelShopSelected: (data) => {
            if (!data) return;
            const address = [data.Adresse1, data.Adresse2, `${data.CP} ${data.Ville}`, data.Pays]
              .filter(Boolean)
              .join(", ");
            onSelectRef.current &&
              onSelectRef.current({
                id: data.ID,
                name: data.Nom || "Point Relais",
                address,
              });
          },
        });
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="mt-3" data-testid="mondial-relay-picker">
      <input type="hidden" id="mr-selected-id" />
      <div ref={ref} className="mr-widget rounded-xl overflow-hidden border border-[var(--oz-border)]" />
    </div>
  );
};

export default MondialRelayPicker;
